import { FC } from 'react'
import styles from './FeatureIcons.module.scss'

const icons = [
	{
		src: 'https://eightsleep.imgix.net/heart_rate.svg?v=1654271753',
		name: 'Heart Rate',
	},
	{
		src: 'https://eightsleep.imgix.net/hrv.svg?v=1654271753',
		name: 'HRV',
	},
	{
		src: 'https://eightsleep.imgix.net/respiratory_rate.svg?v=1654271753',
		name: 'Respiratory Rate',
	},
	{
		src: 'https://eightsleep.imgix.net/time_slept.svg?v=1654271753',
		name: 'Time Slept',
	},
	{
		src: 'https://eightsleep.imgix.net/sleep_stages.svg?v=1654271753',
		name: 'Sleep Stages',
	},
	{
		src: 'https://eightsleep.imgix.net/moon_x.svg?v=1654523158',
		name: 'Disturbances',
	},
]

export const FeatureIcons: FC = () => {
	return (
		<div className={styles.root}>
			<div className={styles.icons}>
				{icons.map((icon, i) => (
					<div key={`icn-${i}`}>
						<img
							src={icon.src}
							alt=""
						/>
						<span>{icon.name}</span>
					</div>
				))}
			</div>
		</div>
	)
}
